import React, { useState, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const SalesModal = ({ isOpen, onClose, sale, onSave, drivers, cars }) => {
    const { isDark } = useTheme();
    // drivers and cars now come from props
    const [formData, setFormData] = useState({
        driver_id: '',
        car_id: '',
        date_received: '',
        expected_date: '',
        amount: '',
        amount_expected: '',
        payment_mode: '',
        days_sales_amount_covers: '',
        status: '',
        notes: ''
    });
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([]);

    // Removed internal fetch logic

    useEffect(() => {
        if (sale) {
            // ... existing code ...
        } else {
            setFormData({
                driver_id: '',
                car_id: '',
                date_received: new Date().toISOString().split('T')[0],
                expected_date: '',
                amount: '',
                amount_expected: '',
                payment_mode: '',
                days_sales_amount_covers: '',
                status: 'YET_TO_SEND',
                notes: ''
            });
        }
    }, [sale, isOpen]);

    // Removed fetchDrivers and fetchCars functions

    const handleChange = (e) => {
        // ... existing code ...
    };

    const handleSubmit = async (e) => {
        // ... existing code ...
    };

    if (!isOpen) return null;

    const styles = {
        // ... existing code ...
    };

    return (
        <div style={styles.overlay} onClick={onClose}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                <h2 style={styles.header}>
                    {sale ? 'Edit Sale' : 'New Sale'}
                </h2>

                {errors.length > 0 && (
                    <div style={styles.errorContainer}>
                        {errors.map((error, index) => (
                            <div key={index}>{error}</div>
                        ))}
                    </div>
                )}

                <form onSubmit={handleSubmit} style={styles.grid}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Driver *</label>
                        <select
                            name="driver_id"
                            value={formData.driver_id}
                            onChange={handleChange}
                            style={styles.input}
                            required
                        >
                            <option value="">Select Driver</option>
                            {drivers.map(driver => (
                                <option key={driver.id} value={driver.id}>
                                    {driver.first_name} {driver.last_name} - {driver.car_number || 'No Car'}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>Car *</label>
                        <select
                            name="car_id"
                            value={formData.car_id}
                            onChange={handleChange}
                            style={styles.input}
                            required
                        >
                            <option value="">Select Car</option>
                            {cars.map(car => (
                                <option key={car.id} value={car.id}>
                                    {car.car_number} - {car.model} - {car.driver_name || 'No Driver'}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>Date Received *</label>
                        <input
                            type="date"
                            name="date_received"
                            value={formData.date_received}
                            onChange={handleChange}
                            style={styles.input}
                            required
                        />
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>Expected Date</label>
                        <input
                            type="date"
                            name="expected_date"
                            value={formData.expected_date}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>Amount Received (GHS) *</label>
                        <input
                            type="number"
                            name="amount"
                            value={formData.amount}
                            onChange={handleChange}
                            style={styles.input}
                            required
                        />
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>Amount Expected (GHS)</label>
                        <input
                            type="number"
                            name="amount_expected"
                            value={formData.amount_expected}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>Payment Mode</label>
                        <select
                            name="payment_mode"
                            value={formData.payment_mode}
                            onChange={handleChange}
                            style={styles.input}
                        >
                            <option value="">Select Mode</option>
                            <option value="Cash">Cash</option>
                            <option value="Mobile Money">Mobile Money</option>
                            <option value="Bank Transfer">Bank Transfer</option>
                            <option value="Cheque">Cheque</option>
                        </select>
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>Days Sales Covers</label>
                        <input
                            type="number"
                            name="days_sales_amount_covers"
                            value={formData.days_sales_amount_covers}
                            onChange={handleChange}
                            style={styles.input}
                            placeholder="e.g., 1"
                        />
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>Status</label>
                        <select
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                            style={styles.input}
                        >
                            <option value="YET_TO_SEND">Yet to Send</option>
                            <option value="SENT_BY_DRIVER">Sent by Driver</option>
                            <option value="RECEIVED">Received</option>
                        </select>
                    </div>

                    <div style={{ ...styles.formGroup, ...styles.fullWidth }}>
                        <label style={styles.label}>Notes</label>
                        <textarea
                            name="notes"
                            value={formData.notes}
                            onChange={handleChange}
                            style={{ ...styles.input, minHeight: '100px', resize: 'vertical' }}
                        />
                    </div>

                    <div style={styles.buttonGroup}>
                        <button
                            type="button"
                            onClick={onClose}
                            style={styles.cancelButton}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            style={styles.saveButton}
                        >
                            {loading ? 'Saving...' : (sale ? 'Update' : 'Create')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SalesModal;
